export enum AppointmentTypes {
    Virtual = 1,
    InPerson = 2,
}
